// modeButtonTheme.js
import { createTheme } from "@mui/material/styles";

const modeButtonTheme = createTheme({
  palette: {
    primary: {
      main: "#4CAF50", // Green (Edit)
    },
    secondary: {
      main: "#1976D2", // Blue (View)
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
          fontWeight: 500,
          padding: "6px 18px",
          minWidth: "110px",
          transition: "all 0.2s ease",
        },

        outlined: {
          borderWidth: "2px",
        },

        contained: {
          boxShadow: "none",

          "&:hover": {
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          },
        },
      },
    },
  },
});

export default modeButtonTheme;
